import { render, staticRenderFns } from "./barging-nomination-form.vue?vue&type=template&id=a90b9d8e&scoped=true&"
import script from "./barging-nomination-form.vue?vue&type=script&lang=js&"
export * from "./barging-nomination-form.vue?vue&type=script&lang=js&"
import style0 from "./barging-nomination-form.vue?vue&type=style&index=0&id=a90b9d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90b9d8e",
  null
  
)

export default component.exports